/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 *
 * @export
 * @interface NewShopProduct
 */
export interface NewShopProduct {
  /**
   *
   * @type {number}
   * @memberof NewShopProduct
   */
  courierId?: number;
  /**
   *
   * @type {string}
   * @memberof NewShopProduct
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopProduct
   */
  description?: string;
  /**
   *
   * @type {number}
   * @memberof NewShopProduct
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof NewShopProduct
   */
  originalPrice?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof NewShopProduct
   */
  images?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof NewShopProduct
   */
  category?: string;
  /**
   *
   * @type {string}
   * @memberof NewShopProduct
   */
  condition?: string;
  /**
   *
   * @type {number}
   * @memberof NewShopProduct
   */
  quantity?: number;
  /**
   *
   * @type {string}
   * @memberof NewShopProduct
   */
  status?: string;
  /**
   *
   * @type {Date}
   * @memberof NewShopProduct
   */
  createdAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof NewShopProduct
   */
  updatedAt?: Date;
}

/**
 * Check if a given object implements the NewShopProduct interface.
 */
export function instanceOfNewShopProduct(
  value: object
): value is NewShopProduct {
  return true;
}

export function NewShopProductFromJSON(json: any): NewShopProduct {
  return NewShopProductFromJSONTyped(json, false);
}

export function NewShopProductFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NewShopProduct {
  if (json == null) {
    return json;
  }
  return {
    courierId: json['courierId'] == null ? undefined : json['courierId'],
    name: json['name'] == null ? undefined : json['name'],
    description: json['description'] == null ? undefined : json['description'],
    price: json['price'] == null ? undefined : json['price'],
    originalPrice: json['originalPrice'] == null ? undefined : json['originalPrice'],
    images: json['images'] == null ? undefined : json['images'],
    category: json['category'] == null ? undefined : json['category'],
    condition: json['condition'] == null ? undefined : json['condition'],
    quantity: json['quantity'] == null ? undefined : json['quantity'],
    status: json['status'] == null ? undefined : json['status'],
    createdAt: json['createdAt'] == null ? undefined : new Date(json['createdAt']),
    updatedAt: json['updatedAt'] == null ? undefined : new Date(json['updatedAt']),
  };
}

export function NewShopProductToJSON(json: any): NewShopProduct {
  return NewShopProductToJSONTyped(json, false);
}

export function NewShopProductToJSONTyped(
  value?: NewShopProduct | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    courierId: value['courierId'],
    name: value['name'],
    description: value['description'],
    price: value['price'],
    originalPrice: value['originalPrice'],
    images: value['images'],
    category: value['category'],
    condition: value['condition'],
    quantity: value['quantity'],
    status: value['status'],
    createdAt: value['createdAt'] == null ? undefined : value['createdAt'].toISOString(),
    updatedAt: value['updatedAt'] == null ? undefined : value['updatedAt'].toISOString(),
  };
}
